"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mobile = void 0;

var Mobile =
/** @class */
function () {
  function Mobile() {}

  Mobile.prototype.MobileDTOType = function () {
    return [{
      slug: 'invitations',
      name: 'Invitations',
      description: null,
      isInvitations: true,
      isEvents: false
    }, {
      slug: 'events',
      name: 'Events',
      description: null,
      isInvitations: false,
      isEvents: true
    }];
  };

  return Mobile;
}();

exports.Mobile = Mobile;